import axios from "axios";
import i18n from "../../../i18n";

const SET_USER_INFO = "SET_USER_INFO";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

const getName = (state) => state.username;
const getEmail = (state) => state.email;
const getPhoneCountry = (state) => state.phoneCountry;
const getPhone = (state) => state.phone;
const getYearBirth = (state) => state.yearBirth;
const getNotifications = (state) => state.notifications;

const initialState = {
  username: "",
  email: "",
  phoneCountry: "",
  phone: "",
  yearBirth: "",
  notifications: null,
};

export function contactInformationFormReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        username: action.username,
        email: action.email,
        phoneCountry: action.phoneCountry,
        phone: action.phone,
        yearBirth: action.yearBirth,
        notifications: action.notifications,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

const sendContactInformation = (formData) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/contactinformation`, formData)
    .then(() => {
      return Promise.resolve(
        i18n.t("appText.participantContactInformation.post.success")
      );
    })
    .catch(() => {
      return Promise.reject(
        i18n.t("errorText.participantContactInformation.post")
      );
    });
};

const fetchParticipant = (id) => (dispatch, getState) => {
  const { studies } = getState().loginReducer;

  const params = {
    participantId: id,
    studyId: studies ? studies[0]?.studyId : null,
  };

  return axios
    .get(`/api/participant/contactinformation`, {
      params,
    })
    .then(({ data }) => {
      dispatch({
        type: SET_USER_INFO,
        username: data.ugnxId,
        yearBirth: data.yearOfBirth,
        email: data.email,
        phoneCountry: data.country,
        phone: data.phoneNumber,
        notifications: data.notifications,
      });
    })
    .catch((e) => {
      dispatch({
        type: SET_USER_INFO,
        username: null,
        yearBirth: null,
        email: null,
        phoneCountry: null,
        phone: null,
        notifications: null,
      });
    });
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    username: getName(state),
    email: getEmail(state),
    phoneCountry: getPhoneCountry(state) || "us",
    phone: getPhone(state),
    yearBirth: getYearBirth(state),
    notifications: getNotifications(state),
  };
};

export const mapDispatchToProps = {
  sendContactInformation,
  fetchParticipant,
  resetState,
};
